import {useEffect} from 'react';
import {
  getElementFromSessionStorage,
  removeElementFromSessionStorage,
  setElementToSessionStorage,
} from 'app/helpers/webStorageUtility';
import {SoftTickerData} from 'app/reducers/softTickerReducer';

export const useStoreSofttickerDataInSessionStorage = (
  softTickerData: SoftTickerData,
  callback: (data: SoftTickerData) => void
) => {
  useEffect(() => {
    const softtickerDataFromStorage = getElementFromSessionStorage('softtickerData');
    if (softtickerDataFromStorage) {
      const parsedSofttickerData = JSON.parse(softtickerDataFromStorage);
      callback(parsedSofttickerData);
      removeElementFromSessionStorage('softtickerData');
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      setElementToSessionStorage('softtickerData', JSON.stringify(softTickerData));
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [softTickerData]);
};
